import { render, staticRenderFns } from "./WalletReverseModal.vue?vue&type=template&id=954f0f5e&"
import script from "./WalletReverseModal.vue?vue&type=script&lang=ts&"
export * from "./WalletReverseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports